export default __webpack_public_path__ + "static/media/arrow_back.74e390f0.svg";